require('jquery');
require('bootstrap');
require('blockui');

import Vue from 'vue';
import App from './App';
import ElementUI from 'element-ui';
import locale from 'element-ui/lib/locale/lang/pt-br';
import store from './store/index';
import VeeValidate from 'vee-validate';
import InputErrors from '@/components/utils/InputErrors';
import '@/utils/leaflet-draw-pt-br.js';
import VueSweetAlert from 'vue-sweetalert';

import './validations';

// Imports CSS
import 'leaflet/dist/leaflet.css';
import 'leaflet-draw/dist/leaflet.draw-src.css';
import 'leaflet-minimap/src/Control.MiniMap.css';
import 'font-awesome/css/font-awesome.css';
import 'mdi/css/materialdesignicons.css';
import '@/assets/fonts/lemaf/lemaf.css';
import '@/styles/main.scss';
import '@/styles/leaflet-beautify-marker-icon.css';
import 'element-ui/lib/theme-chalk/index.css';

import 'leaflet-contextmenu/dist/leaflet.contextmenu.min.css';

// Configurações Vue
Vue.config.productionTip = false;

Vue.component('input-errors', InputErrors);

Vue.prototype.$bus = new Vue();
Vue.use(ElementUI, { locale });

Vue.use(VeeValidate, {classes: true, locale: 'pt_BR'});

Vue.use(VueSweetAlert);

/* eslint-disable no-new */
new Vue({
	el: '#app',
	store,
	template: '<App/>',
	components: { App }
});

/* Hot reload para o Vuex */
if (module.hot) {

	module.hot.accept(['./store/index'], () => {

		const newStore = require('./store/index').default;
		store.hotUpdate(newStore);
	});
}



// WEBPACK FOOTER //
// ./src/main.js